import { Close } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';

export default function InviteRolePrivilegePreview({ open, onClose, role }) {
  const division = [];

  role?.privileges?.map((i) => {
    const exists = division?.find((x) => x === i?.division);
    if (!exists) {
      division.push(i?.division);
    }
  });

  console.log(division);

  console.log(role);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          {role?.roleName}
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Grid2 container spacing={2}>
          {division?.map((i) => {
            return (
              <Grid2
                size={{ lg: 4, md: 4, sm: 6, xs: 12 }}
                sx={{ border: 1, borderColor: 'divider', p: 3, boxShadow: 1 }}
              >
                <List
                  subheader={
                    <Typography fontWeight={600} mb={2}>
                      {i}
                    </Typography>
                  }
                >
                  {role?.privileges
                    ?.filter((x) => x.division === i)
                    ?.map((k) => {
                      return (
                        <ListItem sx={{ m: 0, p: 0 }}>
                          <ListItemText sx={{ m: 0, p: 0 }}>
                            <Typography variant="body2">{k?.description}</Typography>
                          </ListItemText>
                        </ListItem>
                      );
                    })}
                </List>
              </Grid2>
            );
          })}
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}
